import { createAction, props } from '@ngrx/store';
import { ResignEmployeeModel } from '../models/employee-business-detail.model';

export const resignEmployee = createAction(
  '[BiDetails] Update ResignEmployee',
  props<{
    request: {
      businessId: string;
      employeeId: string;
      body: ResignEmployeeModel;
    };
  }>()
);

export const resignEmployeeSuccess = createAction('[BiDetails] Update ResignEmployee Success', props<{ response: string }>());

export const resignEmployeeFailure = createAction('[BiDetails] Update ResignEmployee Failure', props<{ error: Error | any }>());
